<section class="bg-shl-light py-24 dark:bg-shl-dark">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <div class="mb-12 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
      <div>
        <h2 class="text-base font-bold uppercase tracking-wide text-shl-sky">
          {{ 'services_section.eyebrow' | translate }}
        </h2>
        <p class="mt-2 text-3xl font-black tracking-tight text-shl-navy dark:text-white sm:text-4xl">
          {{ 'services_section.title' | translate }}
        </p>
      </div>
      <a class="group flex items-center gap-1 text-sm font-bold text-shl-sky hover:text-sky-600" href="#">
        {{ 'services_section.view_all' | translate }}
        <mat-icon fontSet="material-symbols-outlined" class="transition-transform group-hover:translate-x-1">
          arrow_right_alt
        </mat-icon>
      </a>
    </div>
    <div class="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
      @for (item of services.slice(0, 4); track item.title) {
        <app-service-card [service]="item"></app-service-card>
      }
    </div>
    <div
      class="relative mt-16 overflow-hidden rounded-2xl bg-shl-navy px-8 py-12 shadow-2xl sm:px-12 lg:flex lg:items-center lg:justify-between lg:gap-8"
    >
      <div
        class="absolute inset-0 -z-10 bg-[radial-gradient(45rem_50rem_at_top,theme(colors.blue.100),theme(colors.shl.navy))] opacity-20"
      ></div>
      <div
        class="absolute inset-0 -z-10 opacity-20 [background-image:radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]"
      ></div>
      <div class="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-shl-sky/20 blur-3xl"></div>
      <div class="absolute -bottom-20 left-10 h-40 w-40 rounded-full bg-white/10 blur-2xl"></div>

      <div class="relative z-10 max-w-2xl">
        <h2 class="text-2xl font-black text-white sm:text-3xl">
          {{ 'services_section.cta_banner.title' | translate }}
        </h2>
        <p class="mt-3 text-sm text-blue-200 sm:text-base">
          {{ 'services_section.cta_banner.subtitle' | translate }}
        </p>
      </div>
      <div class="relative z-10 mt-8 lg:mt-0">
        <a
          class="inline-flex items-center justify-center rounded-xl bg-white px-6 py-3 text-sm font-bold text-shl-navy shadow-lg transition-transform hover:scale-105"
          href="#quote"
        >
          {{ 'services_section.cta_banner.button' | translate }}
        </a>
      </div>
    </div>
  </div>
</section>
